export default class TriggerLinkOnClick {

    constructor($view) {
        this.$view = $view;
        this.bind();
    }

    bind(){
        this.$view.find('.thumbnail').on('click',(e) => {
            e.preventDefault();
            window.location = this.$view.find('.overlay .item-title a').attr('href');
        });
    }
}


// WEBPACK FOOTER //
// ./public/frontend/js/components/TriggerLinkOnClick.js